// extracted by mini-css-extract-plugin
module.exports = {"root":"📦SearchInput__root--1dIHJ","input":"📦SearchInput__input--1_3Qc","icon":"📦SearchInput__icon--2PyVU"};